import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import { bombasModuleName, bombasStorage } from "../shared/data.service";
import { editRoute, newRouteFemale, configuracaoModuleName } from "../../../shared/services/data.service";
import { Bomba } from "../shared/bomba.model";
import { BombaApiService } from "../shared/bomba-api.service";
import { BombaService } from "../shared/bomba.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { Tanque } from "../../tanques/shared/tanque.model";
import { TanqueNavigationService } from "../../tanques/shared/tanque-navigation.service";
import { BombaNavigationService } from "../shared/bomba-navigation.service";
import { TanqueApiService } from "../../tanques/shared/tanque-api.service";
import { tanquesStorage, tanquesQuery } from "../../tanques/shared/data.service";
import { TanqueService } from "../../tanques/shared/tanque.service";
import { abastecimentosModuleName } from "../../shared/data.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";

@Component({
    template: require('./bomba-form.component.html'),
    styles: [require('./bomba-form.component.css')]
})
export class BombaFormComponent implements OnInit {
    bombasModule:any = bombasModuleName;
    formObject:any = new Bomba();
    tanqueObject:any = new Tanque();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    tanqueSelectId:string = 'tanqueSelect';
    tanqueQuery:any = {};
    fuelName: string = '';

    form:FormGroup;
    ativo = new FormControl('');
    nome = new FormControl('', Validators.required);
    combustivel = new FormControl({value: '', disabled: true});
    numeroPatrimonio  = new FormControl('', Validators.required);
    tanque = new FormControl('', Validators.required);
    hidrometroInicial = new FormControl('', Validators.required);
    automatizado = new FormControl('');

    private returnToOtherForm:boolean = false;
    private otherForm:string;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _bombaService: BombaService,
        private _bombaApiService: BombaApiService,
        private _bombaNavigationService: BombaNavigationService,
        private _tanqueNavigationService: TanqueNavigationService,
        private _tanqueApiService: TanqueApiService,
        private _tanqueService: TanqueService,
        private _autocompleteService:AutoCompleteService,
        private _abastecimentoService: AbastecimentoService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            nome: this.nome,
            tanque: this.tanque,
            combustivel: this.combustivel,
            numeroPatrimonio : this.numeroPatrimonio,
            automatizado: this.automatizado,
            hidrometroInicial: this.hidrometroInicial
        });
    }

    ngOnInit() {
        this.tanqueQuery = this._utilService.cloneObject(tanquesQuery);
        this.isNewAutoComplete();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Bomba = this._utilService.cloneObject(this.formObject);

            if (this.tanqueObject.id) {
                object.tanqueId = this.tanqueObject.id;
                object.combustivelId = this.tanqueObject.combustivelId;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.formObject.id) {
                this.onEditBomba(object);
            } else {
                this.onAddBomba(object);
            }
        }
    }

    getTanqueObject(object: any) {
        if(object.novo) {
            let thisFormObject: any = this.formObject;
            thisFormObject.tanque = this.tanqueObject;

            this._bombaService.setSessionStorage(thisFormObject);

            let toOtherFormObject: any = {
                identificacao: object.text,
                form: bombasStorage
            };

            this._autocompleteService.setSessionStorage(toOtherFormObject, tanquesStorage);
            this._tanqueNavigationService.goToNew();
        } else {
            this.tanqueObject = object;
            this.setFuelName(object.combustivel);

            this._utilService.setSelectOnFormControl(this.form, 'tanque', object);
        }
    }

    tanqueTemplateResult = (function(state: any) {
        return this._tanqueService.templateResult(state, true);
    }.bind(this));

    private onAddBomba(object: Bomba) {
        this._bombaApiService.onPost(object, this.onDone);
    }

    private onEditBomba(object: Bomba) {
        this._bombaApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error) {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        const onDone = (function(Response: any) {
            if (!Response.error) {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma bomba encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._bombaApiService.onGetById(id, onDone);
    }

    private setModelToForm() {
        if (this.formObject.tanque) {
            this.tanqueObject = this.formObject.tanque;
            delete this.formObject['tanque'];

            let text = this._autocompleteService.getTextSelect2(this.tanqueObject, 'identificacao');
            let selectObject:any = {text: text, id: this.tanqueObject.id};

            this._autocompleteService.createOptionOnSelect2(this.tanqueSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.tanqueSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'tanque', this.tanqueObject);

            if (this.tanqueObject.combustivel) {
                this.setFuelName(this.tanqueObject.combustivel);
            }
        }

    }

    private goToList() {
        this._bombaService.clearSessionStorage();
        this._bombaNavigationService.goToList();
    }

    private testSession() {
        let id: number,
            session: any = this._bombaService.getSessionStorage();
        this._bombaService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            if (id) {
                this.setEditSession();
            } else {
                this.setNewSession();
            }
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        let element: any = this.form.controls['hidrometroInicial'];
        element.disable();

        this.getObject(id);
    }

    private setNewNormal() {

    }

    private setEditSession() {
        this.setModelToForm();
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
        this.setModelToForm();
    }

    private isNewAutoComplete() {
        let newAutoComplete: any = this._autocompleteService.getSessionStorage(bombasStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.bomba = newAutoComplete.bomba;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private toLeaveHere() {
        this.goToList();
    }

    private setFuelName(fuel: any) {
        this.fuelName = this._autocompleteService.getTextSelect2(fuel, 'combustivel');
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bomba-form/bomba-form.component.ts
 **/